<template>
  <div class="relative" :style="{}">
    <div class="w-full h-full absolute overflow-hidden">
      <div class="ticket-container w-[calc(100%)] h-[calc(100%)] absolute">
        <slot name="fullBgContent">
          <div class="absolute w-full h-full">
            <slot name="bg"></slot>
          </div>

          <div
            class="grid h-full w-full"
            :style="{
              'grid-template-columns': `repeat(${leftCols + rightCols}, minmax(0, 1fr))`,
            }"
          >
            <div
              class="relative"
              :style="{
                'grid-column': `span ${leftCols} / span ${leftCols}`,
              }"
            >
              <slot name="bgLeft"> </slot>
            </div>

            <div
              class="relative"
              :style="{
                'grid-column': `span ${rightCols} / span ${rightCols}`,
              }"
            >
              <slot name="bgRight"> </slot>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <div
      class="grid h-full"
      :style="{
        'grid-template-columns': `repeat(${leftCols + rightCols}, minmax(0, 1fr))`,
      }"
    >
      <div
        class="relative"
        :style="{
          'grid-column': `span ${leftCols} / span ${leftCols}`,
        }"
      >
        <slot name="left"> </slot>
        <div class="absolute right-0 h-full top-0 flex justify-center">
          <div
            class="absolute w-8 h-4 bg-[#fffcf8] top-0 rounded-b-full -mt-1"
          ></div>
          <div
            class="h-full border-l-4 absolute border-dashed border-[#fffcf8]"
          ></div>
          <div
            class="absolute w-8 h-4 bg-[#fffcf8] bottom-0 rounded-t-full -mb-1"
          ></div>
        </div>
      </div>

      <div
        class="relative"
        :style="{
          'grid-column': `span ${rightCols} / span ${rightCols}`,
        }"
      >
        <slot>
          <div class="bg-yellow-400 w-full h-full">I am right</div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const rect = '/images/ticket/rect.svg'
const ticketMiddle = '/images/ticket/ticket-middle.svg'
const ticketLeft = '/images/ticket/ticket-left.svg'
const ticketRight = '/images/ticket/ticket-right.svg'
const ticketLeftCircle = '/images/ticket/ticket-left-circle.svg'
const ticketRightCircle = '/images/ticket/ticket-right-circle.svg'
const ticketTopCircle = '/images/ticket/ticket-top-circle.svg'
const ticketBottomCircle = '/images/ticket/ticket-bottom-circle.svg'

const props = defineProps({
  leftCols: {
    type: Number,
    default: 1,
  },
  rightCols: {
    type: Number,
    default: 3,
  },
  borderSize: {
    type: String,
    default: '5%',
  },
  middleSizePercent: {
    type: Number,
    default: 10,
  },
  vertBorderSizePerccent: {
    type: Number,
    default: 10,
  },
  leftBorderShape: {
    type: String,
    validator(value) {
      return ['roundedRect', 'circle', 'none'].includes(value)
    },
    default: 'roundedRect',
  },
  rightBorderShape: {
    type: String,
    validator(value) {
      return ['roundedRect', 'circle', 'none'].includes(value)
    },
    default: 'roundedRect',
  },
  topBorderShape: {
    type: String,
    validator(value) {
      return ['roundedRect', 'circle', 'none'].includes(value)
    },
    default: 'circle',
  },
  bottomBorderShape: {
    type: String,
    validator(value) {
      return ['roundedRect', 'circle', 'none'].includes(value)
    },
    default: 'circle',
  },
})

const borderShapesImgs = {
  left: {
    roundedRect: ticketLeft,
    circle: ticketLeftCircle,
  },
  right: {
    roundedRect: ticketRight,
    circle: ticketRightCircle,
  },
  top: {
    roundedRect: '',
    circle: ticketTopCircle,
  },
  bottom: {
    roundedRect: '',
    circle: ticketBottomCircle,
  },
}

const leftShapeImg = computed(
  () => borderShapesImgs.left[props.leftBorderShape] || '',
)
const rightShapeImg = computed(
  () => borderShapesImgs.right[props.rightBorderShape] || '',
)
const topShapeImg = computed(
  () => borderShapesImgs.top[props.topBorderShape] || '',
)
const bottomShapeImg = computed(
  () => borderShapesImgs.bottom[props.bottomBorderShape] || '',
)
</script>

<style></style>
